import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export const getSuggestions = (payload) => MessageBroker.send(RequestUrls.suggestions, payload);

export const getQletLookup = (payload) => MessageBroker.send(RequestUrls.qletlookup, payload);
